import styles from "./imageBanner.module.css";

const ImageBanner = ({ imageUrl, uniqueKey }: { imageUrl: string, uniqueKey: string }) => (
  <div className={styles.image_banner} id={`image_banner-${uniqueKey}`} style={{ backgroundImage: `url(${imageUrl})` }} />
)

export default ImageBanner